import { signal } from '@preact/signals';
import { useEffect } from 'preact/hooks';

import type { MoneyWidget } from './MoneyWidget.js';

// Geldzaken (0069): de widget op Vandaag zit in een eigen chunk; Vandaag importeert alleen dit.

const widget = signal<typeof MoneyWidget | null>(null);

export function LazyMoneyWidget(props: { tick: number }) {
  useEffect(() => {
    if (!widget.value) {
      void import('./MoneyWidget.js')
        .then((m) => (widget.value = m.MoneyWidget))
        .catch(() => undefined);
    }
  }, []);
  const W = widget.value;
  return W ? <W {...props} /> : null;
}
